import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renders AI-produced markdown (headings, bold, lists, tables, code) with a
// clean, readable style similar to Claude / ChatGPT.
export const Markdown = ({ content, className = "" }) => {
  if (!content) return null;
  return (
    <div className={"md-content text-sm leading-relaxed text-slate-700 " + className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...props }) => <h1 className="text-xl font-semibold text-slate-900 mt-5 mb-2 first:mt-0" {...props} />,
          h2: ({ node, ...props }) => <h2 className="text-lg font-semibold text-slate-900 mt-5 mb-2 first:mt-0" {...props} />,
          h3: ({ node, ...props }) => <h3 className="text-base font-semibold text-slate-800 mt-4 mb-1.5" {...props} />,
          h4: ({ node, ...props }) => <h4 className="text-sm font-semibold text-slate-800 mt-3 mb-1" {...props} />,
          p: ({ node, ...props }) => <p className="mb-3 leading-relaxed" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-3 space-y-1" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-3 space-y-1" {...props} />,
          li: ({ node, ...props }) => <li className="leading-relaxed" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-slate-900" {...props} />,
          em: ({ node, ...props }) => <em className="italic" {...props} />,
          a: ({ node, ...props }) => <a className="text-blue-600 underline hover:text-blue-700" target="_blank" rel="noopener noreferrer" {...props} />,
          blockquote: ({ node, ...props }) => <blockquote className="border-l-4 border-slate-200 pl-4 italic text-slate-600 my-3" {...props} />,
          hr: ({ node, ...props }) => <hr className="my-4 border-slate-200" {...props} />,
          code: ({ node, inline, ...props }) =>
            inline
              ? <code className="bg-slate-100 text-slate-800 rounded px-1.5 py-0.5 text-[0.85em] font-mono" {...props} />
              : <code className="block bg-slate-900 text-slate-100 rounded-lg p-3 text-xs font-mono overflow-x-auto my-3" {...props} />,
          table: ({ node, ...props }) => <div className="overflow-x-auto my-3"><table className="w-full text-xs border-collapse" {...props} /></div>,
          thead: ({ node, ...props }) => <thead className="bg-slate-50" {...props} />,
          th: ({ node, ...props }) => <th className="border border-slate-200 px-2 py-1.5 text-left font-semibold" {...props} />,
          td: ({ node, ...props }) => <td className="border border-slate-200 px-2 py-1.5 align-top" {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
